import { getActiveModifierOption } from '../../global/ProductHelpers';
import { ModifierOptionDto, ProductDto, ProductModifierDto } from '../../../types/schema';
import { ToggleModifierOptionAction } from '../../../store/actions/product.actions.types';

export interface UseModifierActionsProps {
  productDetails: Partial<ProductDto> & Pick<ProductDto, 'sku'>;
  modifier: ProductModifierDto;
  selectedModifierOptions?: Pick<ModifierOptionDto, 'value'>[];
  toggleModifierOptionAction: ToggleModifierOptionAction;
  withRedirect: boolean;
}

const useModifierActions = (props: UseModifierActionsProps) => {
  const {
    productDetails,
    modifier,
    selectedModifierOptions,
    toggleModifierOptionAction,
  } = props;

  const activeOption = (() => {
    const { sku } = productDetails;
    const { options, onSelectFunction } = modifier;

    return options?.find(
      ({ value, selected }) => (
        selectedModifierOptions?.find((o) => o.value === value)
        || selected
        || (onSelectFunction?.toLowerCase() === 'setmaterial' && sku.includes(value))
      ),
    );
  })();

  const selectModifierOption = (option: ModifierOptionDto) => {
    const { withRedirect } = props;

    toggleModifierOptionAction(
      {
        modifier,
        option,
      },
      withRedirect,
    );
  };

  return {
    selectModifierOption,
    getActiveModifierOption: (value: string) => (
      getActiveModifierOption(activeOption, value)
    ),
  };
};

export default useModifierActions;
